<template>
    <div :class="containerClass">
        <div :class="spacerClass"></div>
    </div>
</template>

<script>
    export default {
        props: {
            containerClass: {
                type: String,
                default() {
                    return this.$spa.css.layout.sidebar_spacer_container;
                }
            },
            spacerClass: {
                type: String,
                default() {
                    return this.$spa.css.layout.sidebar_spacer;
                }
            }
        }
    }
</script>